// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"672":"82a67b59","676":"5d9764bf"}[chunkId] + ".chunk.css";
};